module.exports = __webpack_public_path__ + "static/media/vFoxx.74c04d45.jpeg";